import { createFileRoute, redirect } from '@tanstack/react-router'

import { exchangeToken } from '@/api/registration'
import { PageLoader } from '@/components/loader'
import { featureEnabled } from '@/lib/feature-flag'
import { identifyUser } from '@/lib/mixpanel'
import { isInIframe } from '@/lib/originHelpers'

type Search = {
  token: string
}

export const Route = createFileRoute(
  '/_unauthenticated/registration/token-exchange'
)({
  validateSearch: (search: Record<string, unknown>): Search => {
    return {
      token: search.token as string,
    }
  },
  loaderDeps: ({ search }) => search,
  loader: async ({ context: { authStore }, deps: { token } }) => {
    if (isInIframe() && featureEnabled('VITE_DPOP_AUTH_ENABLED')) {
      await authStore.getState().generateDPoPKeys()
    }
    const response = await exchangeToken({ token })
    const userId = response?.data?.user_id

    if (!userId) {
      redirect({ to: '/login', throw: true })
    }

    identifyUser(`${userId}`)
    redirect({ to: '/account/debit-card', throw: true })
  },
  onError: () => {
    redirect({ to: '/login', throw: true })
  },
  pendingComponent: PageLoader,
})
